module.exports = __webpack_public_path__ + "img/3.fcc62246.png";